'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import * as ReactBootstrap from 'react-bootstrap';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module5App2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module5,
    app: state.moduleData.data.module5.app2
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module5App2, _Component);

  function Module5App2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module5App2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module5App2.__proto__ || (0, _getPrototypeOf2.default)(Module5App2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 5,
      appId: 2,
      title: 'Summary of Reboot Kids strategies',
      isCompleted: false
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module5App2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Booster Module'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '1. Top tip: Keep serving it up!'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'Offer fruit and/or vegetables'
                ),
                ' to your child at ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'most meals and snacks'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Keep a record of the different fruits and vegetables that you provide children with each day. This can be a helpful way of finding new opportunities to provide children with different fruits and vegetables.'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '2. Top tip: Be a good role model!'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Eat and enjoy fruit and vegetables yourself'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Use ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'positive language to describe fruits and vegetables'
                ),
                ' eg. \'this carrot is so fresh and crunchy!\''
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Do this even when your children are not watching to get into the habit of always telling them at meal and snack times'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Encourage other caregivers to role model healthy eating too'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '3. Understanding serving sizes'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Read over \'What is a serve?\' to learn what a serve of fruit and vegetables, and other foods look like'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '4. Limit \'sometimes\' foods'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Store sometimes foods in a place that children don\'t know, or in containers that children can\'t see into'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Create a family rule that children must ask before they take a sometimes food (if you don\'t already)'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '5. Prepare healthy meals and snacks'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Use the recipes in the recipes section for ideas about how to include fruit or vegetables in children\'s meals and snacks'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Look at the list of websites for new recipe ideas'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '6. Eat without the TV on'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Encourage children to eat with others in the same location (eg. kitchen or dining room) and without the TV on'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '7. Making fruits and vegetables accessible at home'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'Set aside time each week to chop-up fruit and vegetables. '
                ),
                'A helpful way of doing this is to wash and chop up some of your vegies (and fruit) after shopping'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Keep these in the fridge in airtight containers as ready to eat healthy snacks'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '8. Let your family know what fresh fruit and vegetables are in the home'
          ),
          _react2.default.createElement(
            'h5',
            null,
            '9. Meal planning'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Before you go shopping, use the meal planner and shopping list. This will help to make sure you have enough healthy meals and snacks for children to eat throughout the week'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '10. Use verbal praise and encouragement'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Notice times ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'when children display good behaviour around healthy eating and tell them about it!'
                ),
                ' Use a sentence that explains that you are pleased with them and why'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Use positive words to ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'describe different fruits and vegetables '
                ),
                'and encourage children to taste them, even if they don\'t actually like them.'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Praise example: "What a good boy for sitting at the table"'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Encouragement example: "Yum, this corn is really juicy!"'
          ),
          _react2.default.createElement(
            'h5',
            null,
            '11. Variety is important'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Don\'t avoid providing foods you think children won\'t like'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'You can ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'pair a new or disliked food with a liked food '
                ),
                'eg. add broccoli to a plate of mashed potato and meatballs'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Try not to serve the same vegetables two days in a row. This encourages children to accept variety'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '12. Create teachable moments'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'When you provide children with a new or disliked vegetable, try to make it interesting by',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  ' teaching them something new.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Example: "Did you knwo corn is a member of the grass family?"',
            _react2.default.createElement('br', null),
            'or',
            _react2.default.createElement('br', null),
            '"Broccoli is actually a baby flower that hasn\'t opened yet"'
          ),
          _react2.default.createElement(
            'h5',
            null,
            '13. Make meal times relaxed'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Remember it is the parent\'s responsibility to ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'provide healthy food to children '
                ),
                'and it is the child\'s responsibility to choose how much they want to eat'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Take the focus away from food and talk about other things, like what everyone did during the day'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'Plan to serve a fruit or vegetable at every meal and snack. '
                ),
                'If children refused to eat their vegetables at dinner, you know they had some during the day'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '14. Get kids involved'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Let children ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'help in the kitchen'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Pre-school age children can wash vegies, mash potato, cut snow peas and beans witha plastic knife, and put things away'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Older children can do the same, and can also learn how to cut softer fruits and vegetables, eg. kiwi fruit, banana and snow peas, make fruit or vegetable skewers, and cook vegetables with supervision'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '15. Make vegetables or meals look appealing, exciting or fun'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Use our recipe ideas like pizza people'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Prepare meals with ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'vegies mixed in. '
                ),
                'This is a great way of getting kids to eat their vegies'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Also provide a ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'sample of vegetables on their own so that children become familiar with them'
                )
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '16. Involve children in decision making'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Encourage children, when possible, to make some decisions about the meals and snacks you provide. Be mindful to limit their choices (eg. give children a choice between 2 different vegies)'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '17. Don\'t use food rewards and stay positive'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Avoid using food as a reward (eg. "you can have dessert if you eat your vegetables"). As long as you provide a range of healthy foods, you are fulfilling your role'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '18. Getting support from others'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Chat to other family members or caregivers about your families approach to healthy eating. Together, try to come up with some ideas and a plan that you can agree on'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '19. Learn tips for shopping with children'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Read the tips fact sheet'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '20. Use time-out'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Explain to children that when they choose a bad behaviour [provide them with examples] they will have time-out. Show children where the time-out space is (eg. chair and explain how long it will be [using a timer])'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '21. Stick to the rules'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'As a family, ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'create rules about food and eating.'
                ),
                ' Have the rules written down or drawn as pictures to help children remember them. If a child breaks the rules, know what the consequences are and stick to it'
              )
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            '22. Plan for difficult situations'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'If you run out of time to buy or prepare healthy meals and snacks for the week,',
                _react2.default.createElement(
                  'strong',
                  { className: styles.greenText },
                  'try to cook or buy a bit extra and freeze them'
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
        )
      );
    }
  }]);
  return Module5App2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module5App2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/5/App/App2.js
// module id = 1216
// module chunks = 0